"use client"

import { useEffect } from "react"
import { useApi, API_ENDPOINTS } from "@/lib/api"
import { applyTenantTheme, parseThemeAttributes } from "@/lib/tenant-theme"

// Fetched once per session — the host applies the same configuration for the
// whole login, so there is nothing to re-check per navigation
let hasFetchedTenantTheme = false

/**
 * Renders nothing; on mount fetches the tenant's TenantTheme Global
 * Configuration (the same document appNext's ThemeService consumes) and
 * applies it over the FBO preset palette. Tenants without a configuration —
 * or any fetch failure — keep the presets.
 */
export function TenantThemeProvider() {
  const { adminApi } = useApi()

  useEffect(() => {
    if (hasFetchedTenantTheme) return
    hasFetchedTenantTheme = true

    adminApi
      .get<any[]>(API_ENDPOINTS.ADMIN.TENANT_THEME)
      .then((configurations) => {
        const data = configurations?.[0]?.Data ?? configurations?.[0]?.data
        const attributes = parseThemeAttributes(data)
        if (attributes.length > 0) {
          applyTenantTheme(attributes)
        }
      })
      .catch((err) => {
        // Presets stay in effect; allow a retry on the next mount. Logged because
        // a CORS/config failure here is otherwise invisible (the page just stays
        // on the default palette).
        console.warn("Tenant theme not applied — using FBO preset palette:", err)
        hasFetchedTenantTheme = false
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
